import { noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import { Label } from '../Field'
import Icon from '../Icon'
import SemanticRadio from './SemanticRadio'

type TWrapper = {
  disabled?: boolean
}
export type TOption = {
  label?: string | JSX.Element
  disabled?: boolean
  value?: any
  description?: string | JSX.Element
  tooltip?: string | JSX.Element
}
type TRadio = {
  value?: any
  onChange?: (val: any) => void
  option?: TOption
  inline?: boolean
  label?: string
  disabled?: boolean
  toggle?: boolean
}
const Wrapper = styled.div<TWrapper>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

Wrapper.displayName = 'Wrapper'

const Radio = (props: TRadio): React.ReactElement => {
  const {
    toggle,
    value,
    onChange = noop,
    option = {},
    inline = false,
    label = '',
    disabled = false,
  } = props

  if (toggle) {
    return <SemanticRadio {...props} />
  }

  const isActive = value === option.value

  const isDisabled = disabled || option.disabled

  const onClick = (): void => (isDisabled ? noop() : onChange(option.value))

  return (
    <Wrapper
      onClick={onClick}
      className={`${inline ? 'd-inline-block' : 'd-block'} ${
        inline ? 'mr-2' : ''
      } ${isDisabled ? 'text-muted' : ''}`}
      disabled={isDisabled}
    >
      <div className="d-flex align-items-center">
        {!isActive && <Icon icon="far fa-circle" size={1.1} />}
        {isActive && <Icon icon="far fa-dot-circle" size={1.1} />}
        <div className="ml-1">
          <Label tooltip={option.tooltip}>{option.label || label}</Label>
        </div>
        {/* <div className="ml-1">{option.label || label}</div> */}
      </div>
    </Wrapper>
  )
}

export default Radio
